var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4417 1.17199L7.49542 1.57007L8.44177 15.706L14.388 15.3079L13.4417 1.17199Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.336 14.9166L19.6157 4.12167L16.0465 1L13.4378 1.17464L14.3874 15.3095L20.336 14.9166Z",
    fill: "#DBDBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2647 4.33997L19.6156 4.12167L16.0464 1L16.2647 4.33997Z",
    fill: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8302 9.81386L9.23566 10.4562L9.33773 11.9809L18.9323 11.3385L18.8302 9.81386Z",
    fill: "#0A3B87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6534 7.15833L13.8616 7.47913L13.9636 9.00381L18.7555 8.68301L18.6534 7.15833Z",
    fill: "#1E2D4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8609 7.47767L9.06903 7.79846L9.1711 9.32314L13.9629 9.00235L13.8609 7.47767Z",
    fill: "#0A3B87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4759 4.50184L13.6841 4.82263L13.7862 6.34731L18.578 6.02652L18.4759 4.50184Z",
    fill: "#1E2D4F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6732 4.82191L8.88135 5.1427L8.98342 6.66738L13.7753 6.34659L13.6732 4.82191Z",
    fill: "#0A3B87"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5124 2.25184L8.72058 2.57263L8.82265 4.09731L13.6145 3.77652L13.5124 2.25184Z",
    fill: "#0A3B87"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29358 9.42631L9.29006 8.94606C9.81398 8.9024 10.4361 9.24076 10.6544 9.68827L11.1565 10.6924L18.8625 10.103C19.4191 10.0594 19.8994 10.4523 19.943 10.9762L20.2705 20.6687C20.3142 21.1708 19.9103 21.6074 19.3864 21.651L3.75619 22.8844C3.23227 22.9281 2.76293 22.557 2.73018 22.0549L1.36581 10.4632C1.32215 9.93932 1.74784 9.48089 2.29358 9.42631Z",
    fill: "#1E2D4F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.53066 4.90969L0 7.12964L5.27746 20.2776L10.8081 18.0577L5.53066 4.90969Z",
    fill: "#C7C7C7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0692 2.68091L15.0968 12.7227L13.2413 17.0886L10.8182 18.0601L5.53534 4.90756L11.0692 2.68091Z",
    fill: "#C7C7C7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9861 13.9779L15.0968 12.7227L13.2413 17.0886L11.9861 13.9779Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3666 6.51016L2.44263 10.0922L3.01184 11.5103L11.9359 7.92828L11.3666 6.51016Z",
    fill: "#0A3B87"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3409 8.98049L7.88367 10.7687L8.45264 12.1869L12.9099 10.3987L12.3409 8.98049Z",
    fill: "#1E2D4F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.88303 10.7739L3.42609 12.5629L3.9953 13.981L8.45224 12.192L7.88303 10.7739Z",
    fill: "#0A3B87"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3417 11.4427L8.88477 13.2317L9.45398 14.6498L13.9109 12.8608L13.3417 11.4427Z",
    fill: "#1E2D4F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87235 13.2389L4.41541 15.0278L4.98462 16.4459L9.44156 14.657L8.87235 13.2389Z",
    fill: "#0A3B87"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83775 15.6361L5.38049 17.4243L5.94946 18.8425L10.4067 17.0543L9.83775 15.6361Z",
    fill: "#FF4140"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80588 4.38775L7.78027 18.4098L13.6786 19.2619L15.7042 5.23981L9.80588 4.38775Z",
    fill: "#DBDBDB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5938 20.1121L21.1328 9.40449L18.2949 5.60609L15.719 5.23499L13.6888 19.2607L19.5938 20.1121Z",
    fill: "#DBDBDB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8256 8.92422L21.1328 9.40448L18.2949 5.60608L17.8256 8.92422Z",
    fill: "#B3B3B3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6835 13.4446L9.46503 14.957L18.9823 16.3319L19.2008 14.8195L9.6835 13.4446Z",
    fill: "#0A3B87"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8114 11.4892L14.5932 13.0016L19.3466 13.6874L19.5648 12.175L14.8114 11.4892Z",
    fill: "#1E2D4F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0587 10.8091L9.84027 12.3215L14.5935 13.0082L14.812 11.4958L10.0587 10.8091Z",
    fill: "#0A3B87"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 8.87054L14.9815 10.3829L19.7347 11.0696L19.9532 9.55719L15.2 8.87054Z",
    fill: "#1E2D4F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.446 8.16681L10.2275 9.6792L14.9808 10.3658L15.1993 8.85345L10.446 8.16681Z",
    fill: "#0A3B87"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7983 5.60992L10.5798 7.12231L15.3331 7.80896L15.5515 6.29657L10.7983 5.60992Z",
    fill: "#F28629"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8491 10.7362L13.4051 10.8017C12.8484 10.8017 12.2153 11.1401 12.0189 11.5657L11.5714 12.5044V22.9173H20.4343C20.9909 22.9173 21.4494 22.5462 21.4494 22.0987L21.9187 11.5985C21.9187 11.1291 21.4385 10.7362 20.8491 10.7362Z",
    fill: "#0A3B87"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3633 12.5262C2.7739 12.5262 2.29364 12.9082 2.29364 13.3885L2.76298 22.0986C2.76298 22.5461 3.22141 22.9172 3.77807 22.9172H11.5713V12.5044L3.3633 12.5262Z",
    fill: "#0A3B87"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0455 11.7949C21.0455 12.0896 20.8054 12.3188 20.5216 12.3188H13.5579C13.2631 12.3188 13.0339 12.0787 13.0339 11.7949C13.0339 11.5002 13.2741 11.271 13.5579 11.271H20.5216C20.8163 11.271 21.0455 11.5111 21.0455 11.7949Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.169 16.4447C14.0162 16.4447 13.8634 16.4556 13.7215 16.4883C13.5141 15.3095 12.4881 14.4036 11.2438 14.4036C9.85764 14.4036 8.7334 15.5278 8.7334 16.914C8.7334 17.0341 8.74432 17.1541 8.76615 17.2742C7.80563 17.3506 7.06342 18.1583 7.06342 19.1297C7.06342 20.1667 7.90387 20.9962 8.92987 20.9962H14.18C15.4352 20.9962 16.4612 19.9702 16.4612 18.715C16.4612 17.4597 15.4352 16.4337 14.18 16.4337L14.169 16.4447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.ea82466880ecc225893900caa6a7533e.svg";
export { ForwardRef as ReactComponent };